export default __webpack_public_path__ + "static/media/gardenscapes@2x.aa3d943a.webp";